import { useState, useEffect } from "react";
import { useData, useDispatch } from "./DataContext.js";
import { style } from "./Style.js";

import Button from "react-bootstrap/Button";

import TitlePage from "./TitlePage.js";
import Play from "./Play.js";
import Session from "./Session.js";

import NewPlayModal from "./NewPlayModal.js";
import LoadPlayModal from "./LoadPlayModal.js";
import AdminLoginModal from "./AdminLoginModal.js";
import NewSessionModal from "./NewSessionModal.js";
import LoadSessionModal from "./LoadSessionModal.js";
import StatsModal from "./StatsModal.js";
import CreditModal from "./CreditModal.js";


export default function Main (props)
{
    const gData = useData();
    const gDispatch = useDispatch();

    const [showNewPlay, setShowNewPlay] = useState(false);
    const [showLoadPlay, setShowLoadPlay] = useState(false);
    const [showAdminLogin, setShowAdminLogin] = useState(false);
    const [showNewSession, setShowNewSession] = useState(false);
    const [showLoadSession, setShowLoadSession] = useState(false);
    const [showStats, setShowStats] = useState(false);
    const [showCredit, setShowCredit] = useState(false);

    const [isFullscreen, setIsFullscreen] = useState(false);

    function loadPlay () { gDispatch({ type: "loadPlay" }); }

    useEffect(() => {
	const onFullscreenChange = () => setIsFullscreen(Boolean(document.fullscreenElement));
	document.addEventListener("fullscreenchange", onFullscreenChange);
	return () => document.removeEventListener("fullscreenchange", onFullscreenChange);
    }, []);

    
    // RENDER

    if (gData.session.currentSessionId !== null) return (<Session isFullscreen={isFullscreen}/>);
    else if (gData.state.currentPlayId !== null) return (<Play isFullscreen={isFullscreen}/>);
    else {
	const adminLogin = gData.session.password !== null;
	
	return (
	    <>
		<TitlePage>
		    <div className="position-absolute w-100" style={{ bottom: "20%" }}>
			<div className="d-flex flex-column align-items-center gap-2">
			    {localStorage.getItem("playState") !== null && (<Button variant={style.button.variant} size="lg" onClick={() => { loadPlay(); }} style={{ width: "300px" }}>Partie en cours</Button>)}
			    <Button variant={style.button.variant} size="lg" onClick={() => { if (localStorage.getItem("playState") === null) setShowNewPlay(true); else setShowLoadPlay(true); }} style={{ width: "300px" }}>Nouvelle partie</Button>
			</div>
			<div className="mt-4 d-flex flex-column align-items-center gap-2">
			    <Button variant={style.button.outlineVariant} size="lg" onClick={() => setShowAdminLogin(true)} style={{ width: "300px" }} className={adminLogin ? "d-none" : ""}>Interface enseignant</Button>
			    <Button variant={style.button.outlineVariant} size="lg" onClick={() => setShowNewSession(true)} style={{ width: "300px" }} className={"" + (adminLogin ? "" : "d-none")}>Nouvelle session</Button>			    
			    <Button variant={style.button.outlineVariant} size="lg" onClick={() => setShowLoadSession(true)} style={{ width: "300px" }} className={"" + (adminLogin ? "" : "d-none")}>Session existante</Button>
			    <Button variant={style.button.outlineVariant} size="lg" onClick={() => setShowStats(true)} style={{ width: "300px" }} className={"" + (adminLogin && gData.session.main ? "" : "d-none")}>Statistiques</Button>
			    <Button variant={style.button.outlineVariant} size="lg" onClick={() => setShowCredit(true)} style={{ width: "300px" }}>Crédits et contacts</Button>
			</div>
		    </div>
		</TitlePage>
		{/* <div className="position-absolute top-0 end-0 m-3">
		    <Button variant={style.button.variant} size="lg" className="rounded rounded-5" onClick={() => setShowNewPlay(true)}><BsQuestionLg className="fs-3 px-0 py-0"/></Button>
		    </div> */}
		<NewPlayModal show={showNewPlay} hide={() => setShowNewPlay(false)}/>
		<LoadPlayModal show={showLoadPlay} hide={() => setShowLoadPlay(false)} newPlay={() => { setShowLoadPlay(false); setShowNewPlay(true); }} loadPlay={loadPlay}/>
		<AdminLoginModal show={showAdminLogin} hide={() => setShowAdminLogin(false)}/>
		<NewSessionModal show={showNewSession} hide={() => setShowNewSession(false)}/>
		<LoadSessionModal show={showLoadSession} hide={() => setShowLoadSession(false)}/>
		<StatsModal show={showStats} hide={() => setShowStats(false)}/>
		<CreditModal show={showCredit} hide={() => setShowCredit(false)}/>
		{/* <Offcanvas show={adminLogin} onHide={() => {}} placement="bottom" className="bg-dark text-light" backdrop={false} style={{ height: "100px" }}>
		    <Offcanvas.Body className="h-100 d-flex">
		    <Button variant={style.button.outlineVariant} size="lg" onClick={() => setShowNewSession(true)} style={{ width: "300px" }}>Nouvelle session</Button>			    
		    <Button variant={style.button.outlineVariant} size="lg" onClick={() => setShowLoadSession(true)} style={{ width: "300px" }}>Session existante</Button>			   
		    </Offcanvas.Body>
		    </Offcanvas> */}
	    </>
	);
    }
}
